import { useTranslation } from 'react-i18next';
import { AutoManagedCampaignStatus } from '@anytag/graphql';
import { Form } from '@anytag/shared-atoms';
import { RadiosField } from '@anytag/shared-molecules';
import { AutoManagedCampaignFormKeys } from '../types';

export const Settings = () => {
  const { t } = useTranslation();

  return (
    <>
      <Form.SectionTitle index={3} label={t('Display setting')} />

      <RadiosField<AutoManagedCampaignFormKeys>
        name="status"
        direction="vertical"
        className="mt-4 text-base"
        options={[
          {
            value: AutoManagedCampaignStatus.ACTIVE,
            label: t('Activate this campaign: Show this campaign on AnyCreator')
          },
          { value: AutoManagedCampaignStatus.INACTIVE, label: t('Inactivate this campaign') }
        ]}
      />
    </>
  );
};
